<template>
    <div>
        <modal class="upload-meter-record" :display="modalStatus.bizUploadRecord" @modalStatus="closeModal" >
            <h1>上傳電表</h1>
            <div class="upload-meter-record-wrap">
                <div class="type-group h-align">
                    <div class="type-group-btn" @click="insertData.utilityType = 'WATER'">
                        <img v-if="insertData.utilityType === 'WATER'" src="@/assets/img/mb/icon/water_btn.svg" alt="">
                        <img v-else src="@/assets/img/mb/icon/water_btn_gray.svg" alt="">
                    </div>
                    <div class="type-group-btn" @click="insertData.utilityType = 'ELECTRICITY'">
                        <img v-if="insertData.utilityType === 'ELECTRICITY'" src="@/assets/img/mb/icon/ele_btn.svg" alt="">
                        <img v-else src="@/assets/img/mb/icon/ele_btn_gray.svg" alt="">
                    </div>
                    <div class="type-group-btn" @click="insertData.utilityType = 'GAS'">
                        <img v-if="insertData.utilityType === 'GAS'" src="@/assets/img/mb/icon/gas_btn.svg" alt="">
                        <img v-else src="@/assets/img/mb/icon/gas_btn_gray.svg" alt="">
                    </div>
                </div>
                <div class="content">
                    <div class="input-block">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                房源地址
                            </div>
                            <span v-show="error.name" class="error-with-title">{{error.name}}</span>
                        </label>
                        <div class="input-arear">
                            <rent-select-house :key="componentKey" :class="{error: error.cid}" refName="house" :selectMsg="seletcMsg.house" class="select-scroll" @getId="getSelectId" >
                                <ul>
                                    <div class="house-filter">
                                        <img class="search" src="@/assets/img/icon/search_gray.svg" alt="">
                                        <input v-model="selectHouse" placeholder="搜尋地點" type="text">
                                    </div>
                                    <li ref="houseItem" @click="$root.$emit('house-item', selectHouseName(index))"  :data-id="item.contractCid" :data-name="item.contractSeq" v-for="(item, index) in filterHouse" :key="index">
                                        <span class="name" :data-id="item.contractCid" :data-name="item.contractSeq" >業務：{{item.agentName}}</span>
                                        <span class="address" :data-id="item.contractCid" :data-name="item.contractSeq" >
                                            {{item.address}}
                                        </span>
                                    </li>
                                </ul>
                            </rent-select-house>
                        </div>
                    </div>
                    <div class="input-block">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                使用度數
                            </div>
                            <span v-show="error.meter" class="error-with-title">{{error.meter}}</span>
                        </label>
                        <div class="input-arear">
                            <input type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.meter" placeholder="輸入度數">
                        </div>
                    </div>
                    <div class="input-block">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                請拍攝水表
                            </div>
                            <span v-show="error.photo" class="error-with-title">{{error.photo}}</span>
                        </label>
                        <div class="input-arear">
                            <div v-if="pic.length" class="preview">
                                <img class="cancel" @click.prevent="$refs.uploadCover.remove(pic[0])" src="@/assets/img/icon/cancel_black.svg" alt="">
                                <img :src="pic[0].blob" />
                            </div>
                            <div v-show="!pic.length" class="meter-upload">
                                <file-upload
                                class="upload-btn"
                                post-action="/upload/post"
                                input-id="cover"
                                :size="1024 * 5"
                                :maximum="1"
                                :multiple="true"
                                v-model="pic"
                                @input-file="inputFile"
                                @input-filter="inputFilter"
                                ref="uploadCover">
                                    <img class="upload-icon" src="@/assets/img/mb/icon/upload.svg" alt="">
                                    上傳圖片
                                </file-upload>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" :disabled="isDisabled" @click="uploadMeter()">確定</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSelectHouse from '@/components/bussiness/widges/tools/RentSelectHouse.vue';
import FileUpload from 'vue-upload-component';
import { mapGetters } from 'vuex'

import { 
    uploadMeter
    } from "@/apis/company/meterRecord.js"; 
const defaultParams = {
    // cid: null,
    contractSeq: null,
    photo: null,
    utilityType: 'WATER',
    meter: null
}
export default {
    data () {
        return {
            componentKey: 0,
            insertData: JSON.parse(JSON.stringify(defaultParams)),
            error: {
                cid: null,
                contractSeq: null,
                photo: null,
                utilityType: null,
                meter: null
            },
            pic: [],
            selectHouse: null,
            seletcMsg: {
                house: '請選擇房源',
                isDefault: false
            }
        }
    },
    destroyed(){
    },
    watch: {
      pic: {
          handler(val) {
              this.insertData.photo = val[0].file
          },
          deep: true,
      }
    },
    methods: {
        getSelectId: function (value) {
            // console.log(value)
            if( value.ref == 'house' ){
                // this.insertData.cid = value.id
                this.insertData.contractSeq = value.name
                this.seletcMsg.isDefault = true
            }
        },
        selectHouseName: function (index) {
            console.log(this.$refs.houseItem[index].children[1].innerText)
            return this.$refs.houseItem[index].children[1].innerText
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
                console.log('response', newFile)
        
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.msg.error = '請上傳JPG或PNG檔案'
                    return prevent()
                }

                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.msg.error = '檔案最大限制5MB'
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        uploadMeter: function () {
            if(this.checkInput()){
                let formData = new FormData();
                formData.append('contractSeq', this.insertData.contractSeq);
                formData.append('photo', this.insertData.photo);
                formData.append('utilityType', this.insertData.utilityType);
                formData.append('meter', this.insertData.meter);
                uploadMeter(formData)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '上傳成功',type: 'success',closeBtn: false})
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: response.data.errorMsg,type: 'error',closeBtn: false})
                    }
                    this.closeModal()
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        checkInput: function () {
            if(
                // this.insertData.cid &&
                this.insertData.contractSeq &&
                this.insertData.photo &&
                this.insertData.utilityType &&
                this.insertData.meter &&
                // !this.error.cid &&
                !this.error.contractSeq &&
                !this.error.photo &&
                !this.error.utilityType &&
                !this.error.meter 
            ){
                return true
            }else{
                return false
            }
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizUploadRecord'})
            this.insertData = JSON.parse(JSON.stringify(defaultParams))
            this.pic = []
        },
    },
    computed: {
        filterHouse: function () {
            return this.leaseProcessList.filter((house) => {
                if( this.selectHouse ){
                    if(house.address.includes(this.selectHouse)){
                        return house
                    }
                }else{
                    return house
                }
            });
        },
        isDisabled() {
            if(
                // this.insertData.cid &&
                this.insertData.contractSeq &&
                this.insertData.photo &&
                this.insertData.utilityType &&
                this.insertData.meter 
            ){
                return false
            }else{
                return true
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            leaseProcessList: 'GET_BIZ_LEASE_PROCESS_MGT_LIST',
        })
    },
    components: {
        Modal,
        RentSelectHouse,
        FileUpload
    }
}
</script>
<style lang="scss">
    #modal.upload-meter-record{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 42px;
                }
                .upload-meter-record-wrap{
                    width: 384px;
                    padding: 0 32px 0 32px;
                    .type-group{
                        justify-content: space-between;
                        margin-bottom: 24px;
                        .type-group-btn{
                            cursor: pointer;
                        }
                    }
                    .content{
                        margin-bottom: 40px;
                        .input-block{
                            margin-bottom: 24px;
                        }
                        .meter-upload{
                            position: relative;
                            width: 200px;
                            height: 150px;
                            border-radius: 4px;
                            border: dashed 1px #cacfcd;
                            background-color: #ffffff;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            img{
                                margin-bottom: 8px;
                            }
                            .upload-btn{
                                width: 100%;
                                height: 100%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                            }

                        }
                        .preview{
                            width: 200px;
                            display: flex;
                            align-items: center;
                            border-radius: 4px;
                            overflow: hidden;
                            >img{
                                width: 100%;
                            }
                            .cancel{
                                position: absolute;
                                cursor: pointer;
                                top: -14px;
                                left: 180px;
                                width: 31px;
                                z-index: 3;
                            }
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 384px;
                    height: 44px;
                }
            }
        }
    }
    #modal.no-close{
        .cancle{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/leaseMgt/leaseProcess/uploadMeterRecord.vue